/* SMS lightweight selector loader — load the dependent-option core only where variant pickers exist. */
(() => {
  if (!document.querySelector('variant-picker[form-id],script[data-sms-variant-matrix][data-form-id]')) return;
  const loader = document.currentScript || Array.from(document.scripts).find(s => (s.src || '').includes('sms-product-selector-system.js'));
  if (!loader || !loader.src) return;
  const url = new URL(loader.src, location.href);
  url.pathname = url.pathname.replace(/sms-product-selector-system\.js$/, 'sms-product-selector-core.js');
  url.searchParams.set('sms_core', '20260903b');
  const core = document.createElement('script');
  core.src = url.toString();
  core.async = false;
  document.head.appendChild(core);
})();
